import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import StateDataTable from "./state-datatable";
import StateSearch from "./state-search";
import { PincodeAreaModel } from "../../models/cust-address/cust-address-model";
import AppLoading from "../app-loading/app-loading";

const AddState: React.FC = () => {
    const { t } = useTranslation();
    const [stateList, setStateList] = useState<PincodeAreaModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchTerm, setSearchTerm] = useState<any>();

    useEffect(() => {
        fetchData(pageNumber, pageSize);
    }, []);

    const reloadPage = (val: boolean) => {
        if (val) {
            fetchData(pageNumber, pageSize);
        }
    };

    const fetchData = async (pageNumber: number, pageSize: number) => {
        setLoading(true);
        try {
            const response = await UserAddressService.getAllStates(pageNumber, pageSize);
            setStateList(response.states);
            setTotalRecords(response.totalRecords);
        } catch (error) {
            console.error("Error fetching data:", error);
            setStateList([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = async (event: any) => {
        setLoading(true);
        const newPageNumber = Math.floor(event.first / event.rows) + 1;
        setPageNumber(newPageNumber);
        setPageSize(event.rows);

        try {
            const response = await UserAddressService.getAllStatesByfilter(
                searchTerm,
                newPageNumber,
                event.rows
            );
            setStateList(response.states);
            setTotalRecords(response.totalRecords);
        } catch (error) {
            console.error("Error fetching data:", error);
            setStateList([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">
                    <h5 className="ml-1 mb-0">{"View All States"}</h5>
                </div>

                <StateSearch
                    reloadPage={reloadPage}
                    setLoading={setLoading}
                    setPageNumber={setPageNumber}
                    setPageSize={setPageSize}
                    setStateList={setStateList}
                    setTotalRecords={setTotalRecords}
                    setSearchTerm={setSearchTerm}
                    searchTerm={searchTerm}
                />

                <StateDataTable
                    data={stateList}
                    NoofRecords={totalRecords}
                    pageNumber={pageNumber}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                    searchTerm={searchTerm}
                    onDataUpdate={setStateList} 
                   
                />
            </div>

            {loading && <AppLoading />}
        </>
    );
};

export default AddState;
